import workletUrl from "./pcm-recorder.worklet.js?url";

export class PcmRecorder {
  private context: AudioContext | null = null;
  private node: AudioWorkletNode | null = null;
  private chunks: Float32Array[] = [];
  private resolveStop: (() => void) | null = null;
  async start(stream: MediaStream) {
    const context = new AudioContext();
    this.context = context;
    await context.resume();
    await context.audioWorklet.addModule(workletUrl);
    if (this.context !== context) throw new Error("Kayıt iptal edildi.");
    const node = new AudioWorkletNode(context, "pcm-recorder");
    this.node = node;
    node.port.onmessage = (event: MessageEvent<{ samples?: Float32Array; done?: boolean }>) => {
      if (event.data.samples) this.chunks.push(event.data.samples);
      if (event.data.done) this.resolveStop?.();
    };
    const silent = context.createGain();
    silent.gain.value = 0;
    context.createMediaStreamSource(stream).connect(node);
    node.connect(silent).connect(context.destination);
  }
  async stop() {
    if (!this.context || !this.node) throw new Error("Ses kaydı başlatılamadı.");
    const sampleRate = this.context.sampleRate;
    await new Promise<void>((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error("Mikrofon kaydı tamamlanamadı. Tekrar deneyin.")), 3000);
      this.resolveStop = () => { clearTimeout(timer); resolve(); };
      this.node!.port.postMessage("stop");
    });
    const samples = new Float32Array(this.chunks.reduce((sum, chunk) => sum + chunk.length, 0));
    let offset = 0;
    for (const chunk of this.chunks) { samples.set(chunk, offset); offset += chunk.length; }
    this.dispose();
    return { samples, sampleRate };
  }
  dispose() {
    this.resolveStop?.();this.resolveStop = null;
    this.node?.disconnect();this.node = null;
    const context = this.context;this.context = null;
    if (context && context.state !== "closed") void context.close().catch(() => {});
    this.chunks = [];
  }
}
